module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvc2FmYXJpLXBpbm5lZC10YWIuc3ZnIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/safari-pinned-tab.svg
// module id = A6SM
// module chunks = 0